export const state = {
    aircraft1: null,
    aircraft2: null,
    intersectionPoint: null,
    solution: null,
    currentProblem: 1,
    gameMode: 'practice',
    dailyRun: null,
    dailyCompleted: false,
    timeRun: null,
    createScenarioRandom: null,
    scenarioOptions: null,
    submittedLevels: new Set(),
    passedLevels: new Set(),
    scoresByLevel: {},
    scale: undefined,
    viewCenter: { x: 0, y: 0 },
    baseViewCenter: { x: 0, y: 0 },
    viewOffset: { x: 0, y: 0 },
    measurementStep: 'crossing',
    crossingMarked: false,
    qdmConnected: { aircraft1: false, aircraft2: false },
};
